/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Claim_Issue_Photos_RequiredInputs */

const en_claim_issue_photos_required = /** @type {(inputs: Claim_Issue_Photos_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A defective or faulty product needs at least one photo.`)
};

/**
* | output |
* | --- |
* | "A defective or faulty product needs at least one photo." |
*
* @param {Claim_Issue_Photos_RequiredInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const claim_issue_photos_required = /** @type {((inputs?: Claim_Issue_Photos_RequiredInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Claim_Issue_Photos_RequiredInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_claim_issue_photos_required(inputs)
});